// src/pages/SupportPage.jsx
import React, { useState, useEffect } from "react";
import PageBanner from "../components/common/PageBanner";
import SupportContent from "../components/support/SupportContent";
import { useLocale } from "../contexts/LocaleContext";
import { getSupportPageData } from "../api/apiService";

const SupportPage = () => {
  const { locale } = useLocale();
  const [supportPageData, setSupportPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSupportContent = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getSupportPageData(locale);
        setSupportPageData(data);
      } catch (err) {
        setError(err.message || "Failed to load content.");
        setSupportPageData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSupportContent();
  }, [locale]);


  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }

  if (!supportPageData) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">Content not available.</p>
      </div>
    );
  }

  const { banner } = supportPageData;
  const supportCategories = supportPageData.cas_support_categories || [];
  const sidebarTitle = supportPageData.title;
  const bannerTitle = banner?.title;
  const bannerImageUrl = banner?.image?.[0]?.url;

  return (
    <div className="support-page min-h-screen">
      {/* Banner Section */}
      <PageBanner
        title={bannerTitle}
        titleColorIsWhite={banner?.titleColorIsWhite ?? true}
        imageUrl={bannerImageUrl}
      />

      <SupportContent
        supportCategories={supportCategories}
        sidebarTitle={sidebarTitle}
      />
    </div>
  );
};

export default SupportPage;
